import React from "react";


const OtrasAplicaciones = () => {
  return (
    <section className="section-container">
          <h1>
            Otras Aplicaciones del Eneagrama
          </h1>
          <p>
            Como hemos visto, el Eneagrama se puede aplicar en distintos ámbitos y puedo asegurar que en todos ellos se obtienen resultados sorprendentemente óptimos.
          </p>
          <p>
            Como pedagogo y experto en procesos de enseñanza/aprendizaje tengo también un programa sobre <strong>Eneagrama en Educación</strong>, un ámbito donde el Eneagrama ayuda a estudiantes y docentes a identificar sus estilos de aprendizaje, mejorar la enseñanza y adaptar metodologías para un aprendizaje más efectivo y significativo.
          </p>
          <p>
            Como coach ontológico también uso el Eneagrama como herramienta para el <strong>Control del Estrés y Autorelajación Consciente</strong>, relacionando la manera en que cada eneatipo gestiona el estrés y las formas más efectivas para lograr manejarlo de manera eficaz según su eneatipo.
          </p>
          <p>
            Y, sin lugar a dudas, entre mis servicios estrella (acompañando a personas y equipos para que conecten con su máximo potencial) están el <strong>EneaCoaching Profesional</strong>, el <strong>EneaCoaching Esencial</strong> y el <strong>EneaCoaching para Parejas</strong>.
          </p>
          <p>
            Puedes consultar si puedo aplicar el Eneagrama en algún otro ámbito. En caso contrario, me comprometo a proporcionarte un profesional de la Escuela Internacional en Eneagrama Aplicado que pueda usar esta poderosa herramienta en algún ámbito que yo no domino y que pueda ser de tu interés.
          </p>

          <button
            className="btn-contacto"
            onClick={() => {
                window.open(
                "https://wa.me/34696667110?text=Hola. Me gustaría solicitar información sobre otras aplicaciones del Eneagrama.",
                "_blank"
                );
            }}
            >
            Consultar
            </button>
    </section>
  );
};

export default OtrasAplicaciones;
